module.exports = __webpack_public_path__ + "img/mask.4fa38157.png";